<template>
  <component
    :is="$vuetify.breakpoint.smAndDown ? 'v-dialog' : 'v-menu'"
    :value="isActive"
    :max-height="600"
    :min-width="360"
    :max-width="520"
    offset-y
    fullscreen
    hide-overlay
    scrollable
    :close-on-content-click="false"
    :content-class="contentClass"
    @input="onInput"
  >
    <template #activator="{ attrs }">
      <NotificationsButton
        v-bind="attrs"
        :tooltip="title"
        :count="unread_count"
        :loading="isLoadingData"
        :class-button="classButton"
        @click="onInput(!isActive)"
      />
    </template>

    <template v-if="isActiveInner">
      <NotificationsToolbar
        :title="title"
        :unread_count="unread_count"
        :count="listMeta.count"
        class="NotificationsMenu__header"
        @close="onInput(false)"
        @action:readed="onReadAll"
      />

      <NotificationsList
        :list="notifications"
        @action:readed="onRead"
      />

      <v-divider class="NotificationsMenu__list-divider" />

      <v-btn
        v-if="canGetData"
        :loading="isLoading"
        color="primary"
        style="margin: 0 -1px -1px;"
        text
        tile
        @click="onGetMoreData"
        v-text="'Загрузить еще'"
      />
    </template>
  </component>
</template>

<script>
import { BaseTaskQuery, TaskTypes } from '@/api/BaseWS'
import { NotificationModel as Model } from './Model'
import { notificationMapper } from './store'

import { VMenu } from 'vuetify/lib/components/VMenu'
import { VDialog } from 'vuetify/lib/components/VDialog'
import NotificationsButton from './components/NotificationsButton.vue'
import NotificationsToolbar from './components/NotificationsToolbar.vue'
import NotificationsList from './components/NotificationsList.vue'


const pageSize = 50

export default {
  name: 'NotificationsMenu',
  components: {
    VMenu,
    VDialog,
    NotificationsButton,
    NotificationsToolbar,
    NotificationsList,
  },
  props: {
    classButton: [String, Object],
  },
  data() {
    return {
      isActive: false,
      isActiveInner: false,
      title: Model.page_title.index,
      isLoading: false,
      isLoadingData: false,
      isLoadingCount: false,
      contentClass: 'PageNotificationsMenu__content styled-component',
    }
  },
  computed: {
    ...notificationMapper.mapState({
      notifications: 'list',
    }),
    ...notificationMapper.mapState([
      'listMeta',
      'list',
      'unread_count',
    ]),

    canGetData() {
      return this.notifications.length < this.listMeta.count
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...notificationMapper.mapMutations(['incCount']),
    ...notificationMapper.mapActions({
      getCountNotifications: 'getCounts',
    }),
    ...notificationMapper.mapActions([
      'getNotifications',
      'getNewNotifications',
      'getMoreNotifications',
      'readAllNotifications',
      'readNotifications',
    ]),

    async init() {
      await this.onGetCountNotifications()

      const task = {
        type: TaskTypes.notifications,
        callback: this.incCount,
      }

      const taskQuery = new BaseTaskQuery()
      taskQuery.subscribe(task)
      taskQuery.addListener('reopen', this.getCountNotifications)

      this.$once('hook:beforeDestroy', taskQuery.destroy.bind(taskQuery))
    },
    async onGetNotifications() {
      const params = { pageSize }

      try {
        await this.getNotifications(params)
      } catch (e) {
        this.$notice.errors(e)
      }
    },
    async onGetCountNotifications() {
      this.isLoadingCount = true

      try {
        await this.getCountNotifications()
      } catch (e) {
        this.$notice.errors(e)
      }

      this.isLoadingCount = false
    },
    async onGetMoreData() {
      this.isLoading = true
      const params = { pageSize }

      try {
        await this.getMoreNotifications(params)
      } catch (e) {
        this.$notice.errors(e)
      }

      this.isLoading = false
    },
    async onInput(value) {
      if (this.isLoadingData) return

      const countNewNotifications = Math.abs(this.unread_count - this.listMeta.unread_count)

      if (value && !this.listMeta.page) {
        this.isLoadingData = true
        await this.onGetNotifications()
        this.isLoadingData = false
      } else if (value && countNewNotifications > 0) {
        (async () => {
          this.isLoadingData = true
          await this.onGetNotifications()
          this.isLoadingData = false
        })()
      }

      if (value) {
        this.isActiveInner = value
        this.$nextTick(() => {
          this.isActive = value
        })
      } else {
        this.isActive = value
        this.$nextTick(() => {
          this.isActiveInner = value
        })
      }
    },
    async onReadAll(callback) {
      const unwatch = callback?.()

      try {
        await this.readAllNotifications()
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
    async onRead(data, callback) {
      const unwatch = callback?.()
      const payload = [data]

      try {
        await this.readNotifications({ payload })
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
  },
}
</script>

<style lang="scss" src="@/assets/scss/components/_NotificationsMenu.scss"></style>
